import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import EscalationForm from '../components/EscalationForm';
import {
  requestClientEscalation,
  updateClientEscalation,
  requestPatientEscalation,
  updatePatientEscalation,
} from '../../../store/escalation-manager/EscalationManagerActions';
import { requestEscalationTypes } from '../../../store/escalation-types/EscalationTypesActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestUserInfo } from '../../../store/current-user/CurrentUserActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { requestPatientsTypeahead } from '../../../store/patients/PatientsActions';
import { requestClinicLocationsTypeahead } from '../../../store/location-manager/LocationManagerActions';
import Comments from '../components/Comments';
import CommentForm from '../components/CommentForm';
import {
  requestClientEscalationComments,
  addClientEscalationComment,
  updateClientEscalationComment,
  deleteClientEscalationComment,
  requestPatientEscalationComments,
  addPatientEscalationComment,
  updatePatientEscalationComment,
  deletePatientEscalationComment,
} from '../../../store/comments/CommentsActions';
import { requestClient } from '../../../store/client-manager/ClientManagerActions';
import { requestPatient } from '../../../store/patients/PatientsActions';
import { Link } from 'react-router';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class EscalationEdit extends React.Component {
  componentWillMount() {
    if (this.props.params.masterPatientId !== undefined) {
      this.props.getPatientEscalation(this.props.params.escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      });
      this.props.getPatientEscalationComments(this.props.params.escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      });
      this.props.getPatient(this.props.params.masterPatientId, {
        tenantId: this.props.user.queryParams.tenantId,
      });
    }
    if (this.props.params.employerCodeNumber !== undefined) {
      this.props.getClientEscalation(this.props.params.escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      });
      this.props.getClientEscalationComments(this.props.params.escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      });
      this.props.getClient(this.props.params.employerCodeNumber, {
        tenantId: this.props.user.queryParams.tenantId,
      });
    }
    this.props.getCurrentUser();
  }

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 500,
        order: '',
        search,
        filters,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            const email = item.email ? ` (${item.email})` : '';
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}${email}`,
            });
          });
        }
        return options;
      });
  };

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchTypes = () => {
    return this.props
      .getEscalationTypes({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.type }),
          );
        }
        return options;
      });
  };

  searchPatients = (search) => {
    return this.props
      .patientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  onSubmit = (values) => {
    this.props
      .updateClientEscalation(values, {
        tenantId: this.props.user.queryParams.tenantId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Escalation has been saved.');
          if (window.location.href.indexOf('client-manager') > 0) {
            hashHistory.push(
              `/client-manager/detail/${this.props.params.employerCodeNumber}`,
            );
          }
          if (window.location.href.indexOf('escalation-manager') > 0) {
            hashHistory.push(`/escalation-manager/`);
          }
        }
      });
  };

  onPatientSubmit = (values) => {
    this.props
      .updatePatientEscalation(values, {
        tenantId: this.props.user.queryParams.tenantId,
        masterPatientId: this.props.params.masterPatientId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Escalation has been saved.');
          if (window.location.href.indexOf('patient-escalation') > 0) {
            hashHistory.push(`/patient-escalation/`);
          }
          if (window.location.href.indexOf('patients') > 0) {
            hashHistory.push(
              `/patients/profile/${this.props.params.masterPatientId}`,
            );
          }
        }
      });
  };

  onCancel = () => {
    if (window.location.href.indexOf('client-manager') > 0) {
      hashHistory.push(
        `/client-manager/detail/${this.props.params.employerCodeNumber}`,
      );
    }
    if (window.location.href.indexOf('escalation-manager') > 0) {
      hashHistory.push(`/escalation-manager/`);
    }
    if (window.location.href.indexOf('patients') > 0) {
      hashHistory.push(
        `/patients/profile/${this.props.params.masterPatientId}`,
      );
    }
    if (window.location.href.indexOf('patient-escalation') > 0) {
      hashHistory.push(`/patient-escalation/`);
    }
  };

  onAddSubmit = (parentId, message) => {
    this.props
      .addClientMessage(message, {
        tenantId: this.props.user.queryParams.tenantId,
        parentId: parentId,
        escalationId: this.props.params.escalationId,
        employerCodeNumber: this.props.params.employerCodeNumber,
      })
      .then(() =>
        this.props.getClientEscalationComments(this.props.params.escalationId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onPatientAddSubmit = (parentId, message) => {
    this.props
      .addPatientMessage(message, {
        tenantId: this.props.user.queryParams.tenantId,
        parentId: parentId,
        escalationId: this.props.params.escalationId,
        masterPatientId: this.props.params.masterPatientId,
      })
      .then(() =>
        this.props.getPatientEscalationComments(
          this.props.params.escalationId,
          {
            tenantId: this.props.user.queryParams.tenantId,
          },
        ),
      );
  };

  onUpdateSubmit = (id, message) => {
    this.props
      .updateClientMessage(id, message, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getClientEscalationComments(this.props.params.escalationId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onPatientUpdateSubmit = (id, message) => {
    this.props
      .updatePatientMessage(id, message, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getPatientEscalationComments(
          this.props.params.escalationId,
          {
            tenantId: this.props.user.queryParams.tenantId,
          },
        ),
      );
  };

  onDeleteSubmit = (id) => {
    this.props
      .deleteClientMessage(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getClientEscalationComments(this.props.params.escalationId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onPatientDeleteSubmit = (id) => {
    this.props
      .deletePatientMessage(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getPatientEscalationComments(
          this.props.params.escalationId,
          {
            tenantId: this.props.user.queryParams.tenantId,
          },
        ),
      );
  };

  render() {
    const {
      data: { escalation },
      comments,
      user,
      client: { client },
      patient: { patient },
      isExecutive
    } = this.props;

    return (
      <div id="content">
        {escalation.escalationId && (
          <Helmet title={`${escalation.escalationId} – ${hostTitle()}`} />
        )}
        {window.location.href.indexOf('client-manager') > 0 && (
          <BigBreadcrumbs
            items={[
              'Administration',
              { title: 'Client Manager', route: '/client-manager' },
              'Escalation',
            ]}
            icon="fa fa-fw fa-database"
            className=""
          />
        )}
        {window.location.href.indexOf('patients') > 0 && (
          <BigBreadcrumbs
            items={[
              'Administration',
              { title: 'Patients', route: '/patients' },
              'Escalation',
            ]}
            icon="fa fa-fw fa-database"
            className=""
          />
        )}
        {window.location.href.indexOf('escalation-manager') > 0 && (
          <BigBreadcrumbs
            items={[
              'Administration',
              {
                title: 'Client Escalation Manager',
                route: '/escalation-manager',
              },
              'Escalation',
            ]}
            icon="fa fa-fw fa-database"
            className=""
          />
        )}
        {window.location.href.indexOf('patient-escalation') > 0 && (
          <BigBreadcrumbs
            items={[
              'Administration',
              {
                title: 'Patient Escalation Manager',
                route: '/patient-escalation',
              },
              'Escalation',
            ]}
            icon="fa fa-fw fa-database"
            className=""
          />
        )}
        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>Edit Escalation </h2>
            </header>
            <div>
              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                  <div className="row">
                    <div className="col-md-9">
                      <span> EscalationId: {escalation.escalationId} </span>
                      <br />
                      {this.props.params.employerCodeNumber !== undefined &&
                        this.props.params.employerCodeNumber !== '0' && (
                          <span>
                            {' '}
                            Client: {
                              this.props.params.employerCodeNumber
                            } | {client.employerCodeDescription}{' '}
                          </span>
                        )}
                      {this.props.params.masterPatientId !== undefined &&
                        this.props.params.masterPatientId !== '0' && (
                          <span>
                            {' '}
                            Patient:{' '}
                            <Link
                              to={`patients/profile/${this.props.params.masterPatientId}`}
                              target="_blank"
                            >
                              {this.props.params.masterPatientId} |{' '}
                              {patient[0] && patient[0].fullName} |{' '}
                              <Moment
                                date={patient[0] && patient[0].dob}
                                format="MM/DD/YYYY"
                              />
                            </Link>
                          </span>
                        )}
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  {
                    <EscalationForm
                      searchTypes={this.searchTypes}
                      searchUsers={this.searchUsers}
                      isExecutive={isExecutive}
                      searchClients={
                        this.props.params.employerCodeNumber === '0'
                          ? this.searchClients
                          : null
                      }
                      searchPatients={
                        this.props.params.masterPatientId === '0'
                          ? this.searchPatients
                          : null
                      }
                      searchLocations={this.searchLocations}
                      onSubmit={
                        this.props.params.masterPatientId !== undefined
                          ? this.onPatientSubmit
                          : this.onSubmit
                      }
                      onCancel={this.onCancel}
                    />
                  }
                </div>

                {/*Comments Section*/}
                {escalation.escalationId !==
                  '00000000-0000-0000-0000-000000000000' && (
                  <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                    <CommentForm isExecutive={isExecutive}
                      onSubmit={
                        this.props.params.masterPatientId !== undefined
                          ? this.onPatientAddSubmit
                          : this.onAddSubmit
                      }
                      parentId={null}
                    />
                    {comments.isLoading && <div className="spinner" />}
                    <Comments isExecutive={isExecutive}
                      comments={
                        comments && comments.data && comments.data.list
                          ? comments.data.list
                          : []
                      }
                      userid={user.data.id}
                      onUpdateSubmit={
                        this.props.params.masterPatientId !== undefined
                          ? this.onPatientUpdateSubmit
                          : this.onUpdateSubmit
                      }
                      onDeleteSubmit={
                        this.props.params.masterPatientId !== undefined
                          ? this.onPatientDeleteSubmit
                          : this.onDeleteSubmit
                      }
                      onSubmit={
                        this.props.params.masterPatientId !== undefined
                          ? this.onPatientAddSubmit
                          : this.onAddSubmit
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.escalationmanager,
    escalationtypes: state.escalationtypes,
    users: state.users,
    comments: state.comments,
    user: state.currentUser,
    client: state.clientmanager,
    patient: state.patients,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getClient: (employerCodeNumber, params) =>
      dispatch(requestClient(employerCodeNumber, params)),
    getPatient: (masterPatientId, params) =>
      dispatch(requestPatient(masterPatientId, params)),
    getEscalationTypes: (params) => dispatch(requestEscalationTypes(params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getCurrentUser: () => dispatch(requestUserInfo()),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    patientsTypeahead: (params) => dispatch(requestPatientsTypeahead(params)),
    locationsTypeahead: (params) =>
      dispatch(requestClinicLocationsTypeahead(params)),

    getClientEscalation: (escalationId, params) =>
      dispatch(requestClientEscalation(escalationId, params)),
    updateClientEscalation: (escalation, params) =>
      dispatch(updateClientEscalation(escalation, params)),
    getClientEscalationComments: (escalationId, params) =>
      dispatch(requestClientEscalationComments(escalationId, params)),
    addClientMessage: (message, params) =>
      dispatch(addClientEscalationComment(message, params)),
    updateClientMessage: (id, message, params) =>
      dispatch(updateClientEscalationComment(id, message, params)),
    deleteClientMessage: (id, params) =>
      dispatch(deleteClientEscalationComment(id, params)),

    getPatientEscalation: (escalationId, params) =>
      dispatch(requestPatientEscalation(escalationId, params)),
    updatePatientEscalation: (escalation, params) =>
      dispatch(updatePatientEscalation(escalation, params)),
    getPatientEscalationComments: (escalationId, params) =>
      dispatch(requestPatientEscalationComments(escalationId, params)),
    addPatientMessage: (message, params) =>
      dispatch(addPatientEscalationComment(message, params)),
    updatePatientMessage: (id, message, params) =>
      dispatch(updatePatientEscalationComment(id, message, params)),
    deletePatientMessage: (id, params) =>
      dispatch(deletePatientEscalationComment(id, params)),
  }),
)(EscalationEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/EscalationEdit.js